import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { NavigateToWindowWithNativeEvents } from '@components/_common/link/link';
import { GarageInactiveWrapper, Description, SearchCarsButton } from './GarageInactive.styles';
import { AnalyticEvents, AppRoute } from '../../constants';
import { Analytics } from '../../services/analytics-service';

const GarageInactive = () => {
  // Redirect to search cars page
  const handleRedirect = () => {
    Analytics.trackEvent(AnalyticEvents.garageSearchCarsClicked);
    datadogRum.addAction(AnalyticEvents.garageSearchCarsClicked);
    // window.location.pathname = AppRoute.CARS;

    NavigateToWindowWithNativeEvents({
      url: AppRoute.CARS,
      event: 'continue_to_srp',
      payload: {
        source: 'my_cars',
      },
    });
  };

  return (
    <GarageInactiveWrapper>
      <Description>
        As a Carvana owner, get updates, receive special offers, and view up to date valuations on your vehicles.
      </Description>
      <SearchCarsButton onClick={handleRedirect}>Search Cars</SearchCarsButton>
    </GarageInactiveWrapper>
  );
};

export default GarageInactive;
